module.exports = __webpack_public_path__ + "static/media/domain_logo_California.cde44abf.svg";